module.exports = __webpack_public_path__ + "media/images/android-32255d58f815dd8027afff0ebe6625b8.svg";